// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3gzDd","label":"Completed_label__12f0P"};